import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const Kyc = lazyRouteComponent(() => import('../../pages/profile/kyc'))

export const kycRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'kyc',
  component: Kyc,
})
